import { graphql } from "~/gql";

export const BEDROCK_SUGGEST_ASSUMPTIONS_QUERY = graphql(/* GraphQL */ `
  query BedrockSuggestAssumptions($matterId: Float!) {
    bedrockSuggestAssumptions(matterId: $matterId) {
      chosen
      suggested
    }
  }
`);
